import React from "react";
import "./Why_Choose_Us.css";
import { IDS } from "../../../utils/common";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { getwhychooseus } from "../../../utils/apis/common/Common";
import Common_heading from "../../common/common_heading/Common_heading";

function Why_Choose_Us() {
  // Updated static fallback content for software and IT services
  const cards = [
    {
      img: "/assets/images/home/why-choose-us/expert-software.png",
      title: "Expert-Driven Software",
      text:
        "Our team leverages deep technical knowledge to craft high-performance, validated solutions, custom-built for your growth.",
    },
    {
      img: "/assets/images/home/why-choose-us/collaboration.png",
      title: "Seamless Collaboration",
      text:
        "Engage with a partner committed to your digital success. We integrate flawlessly with your workflow for transparent, efficient delivery.",
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);
  const [whychooseus, setWhyChooseUs] = useState([]);

  const getWhyChoose = async () => {
    const res = await getwhychooseus();
    if (res?.success && res.data.length > 0) {
      setWhyChooseUs(res.data);
    } else {
      // Fallback to updated static cards if API is empty or updating
      setWhyChooseUs(cards);
    }
  };

  useEffect(() => {
    getWhyChoose();
  }, []);

  return (
    <section className="why_choose_us_wrapper ">
      <div className="container text-center">
        {/* Subtitle updated to match the design file text */}
        <Common_heading
          title="Why Choose Diligencia?"
          subtitle="We combine expertise, quality, and end-to-end support to deliver reliable and proven software solutions."
        />

        <div className="row g-4 justify-content-center mt-3">
          {whychooseus.map((card, index) => (
            <div key={index} className="col-12 col-md-6">
              <div className="why_us_card h-100 p-4 text-start d-flex align-items-center gap-4">
                <div className="why_us_icon_holder">
                  <img
                    src={card.image ? IDS?.IMG_URL + card?.image : card.img}
                    alt={card.name || card.title}
                    className="why_us_img"
                  />
                </div>
                <div className="why_us_content">
                  <h5>{card.name || card.title}</h5>
                  <p>
                    {card.description
                      ? htmlToReactParser.parse(card.description)
                      : card.text}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Why_Choose_Us;
